/** Home moderna: hero + grid das 8 categorias (cards com gradiente). Clicar
 *  abre o 1º tutorial da categoria (cai no layout sidebar+conteúdo). */
import { categories, tutorials } from '../data';

export function HomeGrid({ onOpen }: { onOpen: (key: string) => void }) {
  const total = Object.keys(tutorials).length;
  return (
    <div>
      {/* Hero */}
      <div className="text-center mb-10 mt-4">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-indigo-100 border border-indigo-200 text-indigo-600 text-2xl mb-4">
          <i className="fas fa-graduation-cap" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight mb-2">Como podemos ajudar?</h1>
        <p className="text-slate-500 max-w-xl mx-auto">
          {total} tutoriais em vídeo e texto pra você dominar o ALIV Hub. Escolha uma categoria ou use a busca no topo.
        </p>
      </div>

      {/* Grid de categorias */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((cat) => {
          const first = cat.items[0];
          return (
            <button
              key={cat.slug}
              onClick={() => first && onOpen(first.key)}
              className="group text-left bg-white border border-gray-200 rounded-2xl p-5 hover:border-indigo-300 hover:shadow-md transition active:scale-[0.98] shadow-sm"
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${cat.gradient} flex items-center justify-center text-white text-xl shadow-md shrink-0 group-hover:scale-110 transition-transform`}>
                  <i className={cat.homeIcon} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-bold text-slate-900 text-base leading-tight mb-1">{cat.title}</h3>
                  <p className="text-xs text-slate-500 leading-snug mb-2">{cat.desc}</p>
                  <span className="text-[11px] font-bold text-slate-400 uppercase tracking-wide">
                    {cat.items.length} {cat.items.length === 1 ? 'tutorial' : 'tutoriais'}
                  </span>
                </div>
              </div>
              {/* prévia dos itens */}
              <div className="mt-4 pt-4 border-t border-gray-100 space-y-1.5">
                {cat.items.slice(0, 3).map((it) => (
                  <div key={it.key} className="flex items-center gap-2 text-xs text-slate-500 group-hover:text-slate-700 transition">
                    <i className={`${it.icon} w-4 text-center text-slate-400`} />
                    <span className="truncate">{it.label}</span>
                  </div>
                ))}
                {cat.items.length > 3 ? (
                  <div className="text-[11px] text-indigo-600 font-bold pl-6">+{cat.items.length - 3} mais…</div>
                ) : null}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
